import { Box } from '@mui/material';
import useOTP from './useOTP';
import OTPInput from 'react-otp-input';
import CountdownTimer from 'app/components/CountdownTimer';

import styles from './otp.module.css';

interface Props {
  setModalOtp?: (newOtp: string) => void;
  length?: number;
}

const OTP = (props: Props) => {
  const { setModalOtp, length } = props;



  const { otp, handleChange, resentOtp } = useOTP({ setModalOtp });

  return (
    <Box>
      <OTPInput
        value={otp}
        onChange={handleChange}
        numInputs={length ? length : 4}
        renderInput={(inputProps) => <input {...inputProps} className={styles.otpInput} />}
        shouldAutoFocus={true}
      />
      <CountdownTimer text={'Qalan vaxt'} repeat={resentOtp} otp={true} />
    </Box>
  );
};

export default OTP;
